import * as React from 'react'
import { SVGProps } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}

const ClockIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={19}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M5.5 2.083V.833h5v1.25h-5Zm1.875 9.313h1.25V6.604h-1.25v4.792ZM8 18.312a7.205 7.205 0 0 1-2.906-.593 7.663 7.663 0 0 1-2.386-1.615 7.662 7.662 0 0 1-1.614-2.385A7.205 7.205 0 0 1 .5 10.812c0-1.027.198-1.996.594-2.906a7.661 7.661 0 0 1 1.614-2.385 7.661 7.661 0 0 1 2.386-1.615A7.205 7.205 0 0 1 8 3.312c.93 0 1.806.157 2.625.47.82.312 1.549.746 2.188 1.301l1.062-1.062.875.875-1.063 1.062c.5.556.928 1.23 1.282 2.021.354.792.531 1.736.531 2.833a7.204 7.204 0 0 1-.594 2.907 7.662 7.662 0 0 1-1.614 2.385 7.663 7.663 0 0 1-2.386 1.615A7.205 7.205 0 0 1 8 18.312Zm0-1.25c1.736 0 3.212-.607 4.427-1.823 1.215-1.215 1.823-2.69 1.823-4.427 0-1.736-.608-3.211-1.823-4.427C11.212 5.17 9.737 4.562 8 4.562c-1.736 0-3.212.608-4.427 1.823C2.358 7.601 1.75 9.076 1.75 10.812c0 1.737.608 3.212 1.823 4.428 1.215 1.215 2.69 1.822 4.427 1.822Z"
      fill="#777877"
    />
  </svg>
)

export default ClockIcon
